const classes = {
  customTextFieldRequireLabel: { color: 'error.main', marginLeft: '2px' },
};

export default classes;
